import { User } from '../../../domain/entities';
import { Roles, SystemRole } from '../../../utils/roles';
import { FirebaseUser } from '../entities';

export class UserMapper {
  static toDomain(firebaseUser: FirebaseUser): User {
    const hasSystemRole = Object.keys(Roles).includes(firebaseUser.role);
    if (!hasSystemRole) throw new Error('User has not a system role');

    return new User({ ...firebaseUser, role: firebaseUser.role as SystemRole });
  }

  static toEntity(user: User): FirebaseUser {
    return new FirebaseUser(user);
  }
}
